var exports = {
  "y": "S0lfVUl",
};

module.exports = exports;
